import { useEffect, useState, useMemo } from "react";
import toast from "react-hot-toast";
import { createUser } from "../../api/admin-users";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { fetchAllUsers } from "../../components/dashboard/venue-table/GetAllUsers";

const AddUserForm = ({ onCreated, onCancel }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("USER");
  const [vendorIds, setVendorIds] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [errors, setErrors] = useState({});

  const roleOptions = [
    { label: "Super Admin", value: "SUPER_ADMIN" },
    { label: "Admin", value: "ADMIN" },
    { label: "User", value: "USER" },
  ];

  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  };

  useEffect(() => {
    (async () => {
      const resp = await fetchAllUsers({ page: 1, limit: 100000 });
      if (resp?.data) setVendors(resp.data);
    })();
  }, []);

  const validateFields = () => {
    const newErrors = {};
    if (!name.trim()) newErrors.name = "Name is required";
    if (!email.trim()) newErrors.email = "Email is required";
    if (!role) newErrors.role = "Role is required";
    if (role === "USER" && vendorIds.length === 0) {
      newErrors.vendorIds = "At least one vendor is required for Users";
    }
    if (!validateEmail(email)) {
      newErrors.email = "Please enter a valid email address";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setEmail(value);

    if (!value) {
      setErrors({ email: "Email is required" });
    } else if (!validateEmail(value)) {
      setErrors({ email: "Please enter a valid email address" });
    } else {
      setErrors({});
    }
  };

  const handleSubmit = async () => {
    if (!validateFields()) return;
    const userData = {
      name,
      email,
      role,
      vendorId: role === "USER" ? vendorIds : [],
    };
    const resp = await createUser(userData);
    if(resp && resp.error) {
      toast.error(resp.message);
      onCancel();
    }
    else {
      toast.success("User created successfully.");
      onCreated(resp?.tempPassword || "");
    }
   
  };

  // const 

  return (
    <div className="w-full h-full bg-white py-4">
      <div className="max-w-3xl mx-auto p-4 space-y-5 bg-white rounded-lg">
        <h1 className="text-xl font-semibold">Add User</h1>

        <div>
          <label className="block text-sm font-medium mb-1">
            Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full border border-gray-300 rounded-md py-2.5 px-3 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
            placeholder="Enter full name"
          />
          {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">
            Email <span className="text-red-500">*</span>
          </label>
          <input
            type="email"
            value={email}
            onChange={handleChange}
            className={`w-full border rounded-md py-2.5 px-3 focus:outline-none focus:ring-1 ${
              errors.email
                ? "border-red-500 focus:ring-red-500 focus:border-red-500"
                : "border-gray-300 focus:ring-blue-500 focus:border-blue-500"
            }`}
            placeholder="Enter email address"
          />
          {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">
            Role <span className="text-red-500">*</span>
          </label>
          <Dropdown
            value={role}
            options={roleOptions}
            onChange={(e) => setRole(e.value)}
            placeholder="Select Role"
            className="w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
          />
          {errors.role && <p className="text-red-500 text-xs mt-1">{errors.role}</p>}
        </div>

        {role === "USER" && (
          <div>
            <label className="block text-sm font-medium mb-1">
              Vendors <span className="text-red-500">*</span>
            </label>
            <MultiSelect
              value={vendorIds}
              options={vendors.map((v) => ({ label: v.email, value: v._id }))}
              onChange={(e) => setVendorIds(e.value)}
              placeholder="Select Vendors"
              className="w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
              filter
              display="chip"
              panelClassName="border border-gray-300 rounded-md shadow-lg"
              itemTemplate={(option) => (
                <div className="px-3 py-2 border-b last:border-none border-gray-200 hover:bg-gray-100 cursor-pointer rounded-md">
                  {option.label}
                </div>
              )}
            />
          
            {errors.vendorIds && <p className="text-red-500 text-xs mt-1">{errors.vendorIds}</p>}
          </div>
        )}

        <div className="flex justify-end gap-3 pt-2">
          <button
            onClick={onCancel}
            className="px-4 py-2 rounded-md border border-gray-300 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-5 py-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white transition"
          >
            Create User
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddUserForm;